module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedLight.2c35ae0.ttf";